import { Logger } from '_common/services';
import { Command } from '../Command';

export class ArrowRightCommand extends Command {
  private event: KeyboardEvent;

  constructor(context: Editor.Edition.Context, event: KeyboardEvent) {
    super(context, {
      scrollIntoSelection: false,
      removePasteOptions: false,
      updateModifiers: false,
    });
    this.event = event;
  }

  async handleExec(): Promise<void> {
    if (this.debug) {
      Logger.trace('ArrowRightCommand exec', this);
    }

    this.buildActionContext();

    if (
      !this.context.DataManager ||
      !this.context.DataManager.selection ||
      !this.context.selection?.modifiers ||
      !this.actionContext
    ) {
      throw new Error('Invalid context');
    }

    // TODO fix page selection if needed

    let shiftKey = this.event.shiftKey;
    let ctrlKey = this.event.ctrlKey;

    if (!shiftKey && !ctrlKey) {
      this.context.selection.modifiers.modify(
        this.actionContext.range,
        'move',
        'character',
        'forward',
      );
    } else if (shiftKey && ctrlKey) {
      this.context.selection.modifiers.modify(
        this.actionContext.range,
        'expand',
        'word',
        'forward',
      );
    } else if (shiftKey) {
      this.context.selection.modifiers.modify(
        this.actionContext.range,
        'expand',
        'character',
        'forward',
      );
    } else if (ctrlKey) {
      this.context.selection.modifiers.modify(this.actionContext.range, 'move', 'word', 'forward');
    }

    this.applySelection();
  }
}
